PasswordProtect = require('./components/password-protect.js');
KBSidebar = require('./components/sidebar.js');
KBVoting = require('./components/voting.js');
Editor = require('./components/editor/editor.js');
Accordion = require('./elements/accordion.js');
KBSearch = require('./components/search.js');

var KB = {
    init: function () {
        jQuery.noConflict();
        PasswordProtect.load();
        KBSidebar.init();
        KBVoting.init();
        KBSearch.init();
        Editor.init();
        Accordion.init();
        this.helpieSyntaxHighlight();
        this.eventHandlers();
    },

    eventHandlers: function () {
        thisModule = this;

        jQuery('.helpie-main-content-area ul.main-nav li a').click(function () {
            jQuery('.helpie-main-content-area ul.main-nav li').removeClass('active');
            jQuery(this).closest('li').addClass('active');
            jQuery('.helpie-main-content-area .content-section').hide();
            jQuery(jQuery(this).data("target")).show();
        });

        jQuery('.category-sidebar ul li a').click(function () {

            jQuery('.category-sidebar ul li').removeClass('active');
            jQuery(this).closest('li').addClass('active');
            jQuery('.category-main-content .category-section').hide();
            jQuery(jQuery(this).data("target")).show();
        });

    },


    /* Helpie Syntax Highlighter */
    helpieSyntaxHighlight: function () {
        // hljs.initHighlightingOnLoad();
        hljs.configure({
            tabReplace: '    ', // 4 spaces
            classPrefix: '' // don't append class prefix
            // … other options aren't changed
        })
        hljs.initHighlighting();
        var clipboard = new Clipboard('.helpie-copy-icon');


        jQuery('.helpie-syntax-highlight code').each(function (index, element) {
            var codeID = jQuery(this).attr('id');
            jQuery(this).after("<a class='helpie-copy-icon' data-clipboard-target='#" + codeID + "'><span class='label'>copy to clipboard</span><i class='fa fa-clipboard' aria-hidden='true'></i></a>")
            var code_content = jQuery(this).html();
            // code_content = this.helpie_htmlDecode(code_content);
            jQuery(this).html(code_content);
        });
    },

    helpie_htmlDecode: function (input) {
        var output = jQuery('<div/>').text(input).html();
        return output;
    },


    helpieCopyfieldvalue: function (e, id) {
        var field = document.getElementById(id);
        // console.log('ID: ' + id);
        var str = JSON.stringify(field);
        var str = JSON.stringify(field, null, 4); // (Optional) beautiful indented output.
        field.focus();
        // console.log('field: ' + str);
        field.setSelectionRange(0, field.value.length);
        var copysuccess = copySelectionText();
        if (copysuccess) {
            showtooltip(e);
        }
    },


};

module.exports = KB;
